import Swiper, { Pagination } from 'swiper';

import 'swiper/swiper-bundle.css';

Swiper.use([Pagination]);

function initSwiper()
{

  new Swiper(".swiper-container", {
    direction: 'vertical',
    speed: 800,
    mousewheelControl: true,
    watchSlidesProgress: true,
    mousewheel: {
      releaseOnEdges: true,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    on: {
      setTransition: function(slider, speed) {
        let swiper = this;
        for (let i = 0; i < swiper.slides.length; i++) {
          swiper.slides[i].style.transition = speed + "ms";
          swiper.slides[i].querySelector(".slide-inner").style.transition =
            speed + "ms";
        }
      }
    }
  });

}

document.addEventListener('DOMContentLoaded', function() {

  var vimeoElement = document.querySelector('.slider_vertical');
  if (vimeoElement) {
      initSwiper();
  }
 
});